import React, { Component } from "react";
import { DataGrid, GridToolbar } from '@material-ui/data-grid'
import axios from 'axios';
import { Backdrop, Button,  CircularProgress,  FormControl, ListItemButton} from "@mui/material";
import Edit from "@material-ui/icons/Edit";
import AddLinkIcon from '@mui/icons-material/AddLink';
import { Typography } from "@material-ui/core";
const url = "https://nrbegzvavi.execute-api.us-east-1.amazonaws.com/dev/medicalteam/find";
   
  
class FindMedicalTeam extends Component {
    state = {
        data:[],
        openLoader: true
    }
    peticionGet = () => {
        axios.post(url, { }).then(response => { 
          
          this.setState({data: response.data});
          this.setState({openLoader: false});
        }); 
    };

    componentDidMount() {
        this.peticionGet();
    }   
   
   
    render() {
       
      const columns = [
            { field: 'id', headerName: 'Cedula', width: 140 , headerAlign: 'center', },
            {
                field: 'fullName',
                headerName: 'Nombres',
                description: 'Nombre Completo.',
                sortable: false,
                headerAlign: 'center',
                width: 240,
                valueGetter: (params) =>
                  `${params.row.firstName || ''} ${params.row.secondName || ''}`,
              },
            { field: 'lastName', headerName: 'Apellidos', width: 250, valueGetter: (params) =>
            `${params.row.lastName || ''} ${params.row.secondLastName || ''}`, },
            { field: 'specialty', headerName: 'Especialidad', headerAlign: 'center', width: 200 , align: 'center',},
            
           
              { field:'escoger', hide:this.props.comeFromMenu, headerName: 'Escoger', align: 'center', headerAlign: 'center',  width: 170 , sortable: false, renderCell: (params) => {
                  return (
                      <div>
                          <ListItemButton onClick={() => {
                              this.props.setMedicalTeam(params.row)
                              this.props.changeMenu(11);
                          }}>
                          <AddLinkIcon />
                          </ListItemButton>
                      </div>
                  );
              } },
              { field:'editar',  hide:!this.props.comeFromMenu, headerName: 'Editar', align: 'center',  width: 170 , headerAlign: 'center', sortable: false, renderCell: (params) => {
                return (
                    <div>
                        <ListItemButton onClick={() => {
                            this.props.setMedicalTeam(params.row);
                            this.props.changeMenu(9);
                        }}>
                        <Edit />
                        </ListItemButton>
                    </div>
                );
            } },
        ];
        return (
            <div style={{ height: 700, width: '100%' }}>
                    <FormControl>
                        <Button variant="contained"  hidden={!this.props.comeFromMenu}  color="primary" onClick={() => {
                             this.props.setMedicalTeam({id:""});
                             this.props.changeMenu(9);
                        }}>
                            Nueva Personal
                        </Button>  
                        <Typography hidden={this.props.comeFromMenu}>Escoger Medico</Typography>  
                    </FormControl>
                   
              <DataGrid
                rows={this.state.data}
                columns={columns}
                pagination
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowCount={100}
                
                //paginationMode="server"
                checkboxSelection={true}
                //autoPageSize={true}
                
                componentsProps={{
                    columnMenu: { background: 'red', counter: this.state.data.length },
                  }}
                  components={{
                    Toolbar: GridToolbar,
                  }}
              />

        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={this.state.openLoader}>
            <CircularProgress color="inherit" />
        </Backdrop>
            </div>
          )
    }
}

export default FindMedicalTeam;
